import "./App.css";
import NavDock from "./components/NavDock";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ExperienceSection from "./components/ExperienceSection";
import SocialProof from "./components/SocialProof";
import ValueProposition from "./components/ValueProposition";
import TechStack from "./components/TechStack";
import BlogSection from "./components/BlogSection";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";

function App() {
  return (
    <div data-testid="app-root" className="min-h-screen">
      <NavDock />

      {/* Page offset for side dock on desktop */}
      <div className="lg:pl-16">
        <HeroSection />
        <AboutSection />
        <ValueProposition />
        <TechStack />
        <ExperienceSection />
        <SocialProof />
        <BlogSection />
        <ContactForm />
        <Footer />
      </div>
    </div>
  );
}

export default App;
